import { render } from "./VueSelect.vue?vue&type=template&id=04ff25a8&ts=true"
import script from "./VueSelect.vue?vue&type=script&lang=ts"
export * from "./VueSelect.vue?vue&type=script&lang=ts"

import "./VueSelect.vue?vue&type=style&index=0&id=04ff25a8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__